/**
 * Query cache timing constants for intervention hooks
 * Centralized to ensure consistency and easy maintenance
 */

export const QUERY_TIMING = {
  /** How long data is considered fresh (won't refetch) */
  STALE_TIME: {
    LIST: 10_000, // 10 seconds - lists change frequently
    CALENDAR: 30_000, // 30 seconds - calendar views are range-bounded
    DETAIL: 30_000, // 30 seconds - individual items change less often
    COUNTS: 30_000, // 30 seconds - counts change with list
    MATCHING: 60_000, // 1 minute - technician matching is expensive
    DOCUMENTS: 30_000, // 30 seconds - documents change infrequently
    FULL: 30_000, // 30 seconds - aggregate detail page data
    FILTER_COUNTS: 30_000, // 30 seconds - filter counts update with list
  },
  /** How long inactive data stays in cache before garbage collection */
  GC_TIME: 300_000, // 5 minutes - shared across all queries
} as const
